export default "__VITE_ASSET__Temt3dsQ__"